<ng-http-loader [backdrop]="true" [backgroundColor]="'#ff0000'" [backdropBackgroundColor]="'#ffffff'" [opacity]="0.3"
   [spinner]="spinkit.skThreeBounce">
</ng-http-loader>
<div class="main-content">
   <div class="container">
      <div class="row justify-content-end" style="margin-top: 2%;">
         <div class="col-md-8 offset-md-4">
            <div class="row">
               <div class="col-md-4">
                  <tc-form-group>
                     <button class="button-btn" (click)="Onclickbutton()">
                        <tc-icon [iconClass]="'icofont-ui-home'" [tcFontSize]="22" [tcColor]="['#fffff', '#fffff']"
                           title="Back to Home" style="margin-top: -5px !important;"></tc-icon>
                        Back To Home
                     </button>
                  </tc-form-group>
               </div>
            </div>
         </div>
      </div>
   </div>
   <div class="container" align="center">
      <div class="row titleFont padd3">
         <div class="col-md-6">
            <div class="row align-items-center">
               <div class="col-12 col-md-4">
                  <tc-form-label class="mb-md-0">Restaurant logo</tc-form-label>
               </div>
               <div class="col-12 col-md-8 " style="margin-top:10%;">
                  <label for="fileInput">
                     <div *ngIf="!currentAvatar">
                        <tc-avatar [src]="defalutimage" [size]="80" class="image"></tc-avatar>
                     </div>
                     <div *ngIf="currentAvatar">
                        <tc-avatar tooltip="choose File" [src]="currentAvatar" [size]="80" class="image"></tc-avatar>
                     </div>
                  </label>
                  <br />
                  <input id="fileInput" type='file' (change)="onImageChange($event)">
                  <label for="fileInput">
                     <p class="text_photo">Change logo</p>
                  </label>
               </div>
            </div>

         </div>
         <div class="col-md-6" style="margin-top: 5%;">
            <div class="row align-items-center ">
               <div class="col-12 col-md-4">
                  <tc-icon [iconClass]="'icofont-web'" [tcFontSize]="30" [tcColor]="['#55b42c', '#5db6bf']" (click)="openUrlOnNewTab(restaurant_desc_link)"></tc-icon>
               </div>
               <div class="col-12 col-md-8" style="margin-left: -20px;">
                  <tc-input [placeholder]="'Restaurant link'" [(ngModel)]="restaurant_desc_link ">{{restaurant_desc_link
                     }}</tc-input>
               </div>
            </div>
            <div class="row align-items-center" style="margin-top: 46px;margin-bottom: 61px;">
               <div class="col-12 col-md-4">
                  <tc-icon [iconClass]="'icofont-location-pin'" [tcFontSize]="30" [tcColor]="['#55b42c', '#5db6bf']" (click)="openUrlOnNewTab(google_map_url)">
                  </tc-icon>
               </div>

               <div class="col-12 col-md-8" style="margin-left: -20px;">
                  <tc-input [placeholder]="'Google Maps link'" [(ngModel)]="google_map_url">
                     {{ google_map_url }}
                  </tc-input>
               </div>
            </div>

         </div>
         <!-- icofont-location-pin -->

      </div>

      <div class="row titleFont padd3">
         <div class="col-md-6" style="margin-top: 5%;">
            <div class="row align-items-center">
               <div class="col-12 col-md-4">
                  <tc-form-label class="mb-md-0">Restaurant details</tc-form-label>
               </div>
               <div class="col-12 col-md-8">
                  <tc-textarea [placeholder]="'Restaurant details'"
                     [(ngModel)]="resto_text">{{resto_text}}</tc-textarea>
               </div>
            </div>
         </div>
         <div class="col-md-6" style="margin-top: -2%;">
            <div class="row align-items-center">
               <div class="col-12 col-md-4">
                  <tc-icon [iconClass]="'icofont-facebook'" [tcFontSize]="30"
                     [tcColor]="['#55b42c', '#5db6bf']" (click)="openUrlOnNewTab(restaurant_desc_fb)"></tc-icon>
               </div>
               <div class="col-12 col-md-8" style="margin-left: -20px;">
                  <tc-input [placeholder]="'facebook page link'"
                     [(ngModel)]="restaurant_desc_fb">{{restaurant_desc_fb}}</tc-input>
               </div>
            </div>
         </div>
      </div>
      <div class="row titleFont padd3 ">
         <div class="col-md-6">
         </div>
         <div class="col-md-6" style="margin-top: -6%;">
            <div class="row align-items-center">

               <div class="col-12 col-md-4">

                  <tc-icon [iconClass]="'icofont-instagram'" [tcFontSize]="30"
                     [tcColor]="['#55b42c', '#5db6bf']" (click)="openUrlOnNewTab(restaurant_desc_insta)"></tc-icon>
                  <!-- <tc-form-label class="mb-md-0">Instagram page link</tc-form-label> -->
               </div>
               <div class="col-12 col-md-8" style="margin-left: -20px;">
                  <tc-input [placeholder]="'Instagram page link'"
                     [(ngModel)]="restaurant_desc_insta">{{restaurant_desc_insta}}</tc-input>
               </div>

            </div>
         </div>
      </div>
      <tc-form-group>
         <div class="col-md-12 py-4">
            <div class="wrapper" align="center">
               <button class="button" [disabled]="!resto_text"
                  (click)="Onupdate(resto_text,restaurant_desc_link,restaurant_desc_fb,restaurant_desc_insta)">Update
                  Details </button>
            </div>
         </div>
      </tc-form-group>
   </div>
</div>